import RequestsActions from 'client/core/RequestsActions'
import { action } from 'client/core/actions'

export const UsersRequest = new RequestsActions('USERS')

/*Set current*/
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const setCurrentUser = (_id) => action(SET_CURRENT_USER, { _id })



// WEBPACK FOOTER //
// ./src/client/features/users/actions.js